import {Tooltip} from "antd";
import {TooltipPlacement} from "antd/es/tooltip";
import {LiteralUnion} from "antd/es/_util/type";
import {PresetColorType} from "antd/es/_util/colors";

interface WizTooltipProps{
    title:string,
    placement?:TooltipPlacement,
    color?:LiteralUnion<PresetColorType>,
    children?: React.ReactNode,
}



function WizTooltip (props:WizTooltipProps) {

    const { children, title, placement, color } = props;

    function getColor()
    {
        const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
        switch (serviceCode) {
            case 'DEFAULT':
                return color || 'rgba(0, 0, 0, 0.8)';
            case 'POSTECH':
                return color || 'rgba(0, 0, 0, 0.8)';
            case 'BUSANPA':
                return color || 'rgba(0, 0, 0, 0.8)';
            default:
                return color || 'rgba(0, 0, 0, 0.8)';
        }
    }

    return (
        <Tooltip color={getColor()} arrow={false} title={title} placement={placement||"bottom"}>
            {children}
        </Tooltip>
    );
};

export default WizTooltip;